import {
  collection,
  doc,
  orderBy,
  query,
  where,
  QueryConstraint,
  getDoc,
  Timestamp,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
} from 'firebase/firestore';
import { DailyPuzzle } from 'types/components/DailyPuzzle';

import { firestore } from '../Firebase';

export type getAllDailyPuzzlesParams = {
  dateSort?: 'asc' | 'desc';
  whereMoreThanDate?: Date | null;
  whereLessThanDate?: Date | null;
};

export const getAllDailyPuzzles = async (params: getAllDailyPuzzlesParams) => {
  const { dateSort, whereMoreThanDate, whereLessThanDate } = params;

  const whereParams: Array<QueryConstraint> = [];

  if (whereMoreThanDate)
    whereParams.push(
      where('date', '>=', Timestamp.fromDate(new Date(whereMoreThanDate.toUTCString()))),
    );
  if (whereLessThanDate)
    whereParams.push(
      where('date', '<=', Timestamp.fromDate(new Date(whereLessThanDate.toUTCString()))),
    );

  const q = query(
    collection(firestore, 'daily_puzzles'),
    ...whereParams,
    orderBy('date', dateSort ?? 'desc'),
  );
  const querySnapshot = await getDocs(q);
  const data: DailyPuzzle[] = [];
  querySnapshot.forEach((doc) => {
    const { puzzleId, date, iconUrl, puzzleName } = doc.data();
    data.push({
      id: doc.id,
      puzzleId,
      date: date.toDate(),
      iconUrl,
      puzzleName,
    });
  });
  return data;
};

export const getDailyPuzzleById = async (id: string) => {
  const docRef = doc(firestore, 'daily_puzzles', id);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    const { puzzleId, date, iconUrl, puzzleName } = docSnap.data();
    return {
      puzzleId,
      date: date?.toDate(),
      iconUrl,
      id: docSnap.id,
      puzzleName,
    };
  }
  return null;
};

export const getDailyPuzzleByPuzzleId = async (id: string) => {
  const q = query(collection(firestore, 'daily_puzzles'), where('puzzleId', '==', id));
  const querySnapshot = await getDocs(q);
  const data: DailyPuzzle[] = [];
  querySnapshot.forEach((doc) => {
    const { puzzleId, date, iconUrl, puzzleName } = doc.data();
    data.push({
      id: doc.id,
      puzzleId,
      date: date.toDate(),
      iconUrl,
      puzzleName,
    });
  });
  return data;
};

export const createDailyPuzzle = async (id: string, data: DailyPuzzle) => {
  const docRef = doc(firestore, 'daily_puzzles', id);
  const date = Timestamp.fromDate(new Date(data.date.toUTCString()));
  return await setDoc(docRef, { ...data, date });
};

export const updateDailyPuzzleById = async (id: string, data: DailyPuzzle) => {
  const docRef = doc(firestore, 'daily_puzzles', id);
  const date = Timestamp.fromDate(new Date(data.date.toUTCString()));
  return await updateDoc(docRef, { ...data, date });
};

export const deleteDailyPuzzleById = async (id: string) => {
  const docRef = doc(firestore, 'daily_puzzles', id);
  return await deleteDoc(docRef);
};
